import styled from 'styled-components';

const TileInfoContainer = styled.div`
  transition: min-height 0.1s ease-out;
`;

const BuildingImage = styled.div`
	flex-grow: 1;
  background-color: #fafafa;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  z-index: 0;
  width: 100%;
	height: 100%;
`;

const Container = TileInfoContainer.extend`

`;

const Info = styled.div`
	position: relative;
  display: flex;
  justify-content: space-between;
	padding: 24px 16px;
	background-color: white;
  color: rgb(77, 77, 77);
`;

const InfoBit = styled.div`
  display: flex;
  flex-direction: column;
  text-align: ${props => props.align || 'left'};
`;

const BiggerText = styled.p`
	font-size: 22px;
	margin-bottom: 4px;
`;
const SmallerText = styled.p`
  font-size: 14px;
`;

const Name = styled.div`
  background-color: rgb(51, 51, 51);
  color: white;
  position: absolute;
  bottom: 100%;
  right: 16px;
  font-size: 14px;
	padding: 8px;
	transform: translateY(50%);
`;

export {
	TileInfoContainer,
	BuildingImage,
	Container,
	Info,
	InfoBit,
	BiggerText,
	SmallerText,
	Name,
}
